export default {
    common: {
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        search: "Search",
        filter: "Filter",
        success: "Success",
        error: "Error",
        confirm: "Confirm",
        back: "Back",
        loading: "Loading...",
        loadMore: "Load More",
        actions: "Actions",
        create: "Create",
        creating: "Creating...",
        required: "is required",
        confirmDelete: "Confirm Delete",
        accessDenied: "Access Denied",
        noPermission: "You do not have permission to access this page",
        dangerZone: "Danger Zone",
        close: "Close",
        refresh: "Refresh",
        noData: "No data available",
        view: "View",
        update: "Update",

        // Web
        cart: "Cart",
        call: "Call us",
        processing: "Processing...",
        english: "English",
        vietnamese: "Tiếng Việt",
        backToHome: "Back to Home",
        continueShopping: "Continue Shopping",
    },
    auth: {
        login: {
            title: "Sign In",
            email: "Email",
            verificationCode: "Verification Code",
            requestCode: "Get Verification Code",
            signIn: "Sign In",
            codeSent: "Verification code has been sent to {{email}}",
            tryAnotherEmail: "Try another email",
            resendCode: "Resend code",
            emailRequired: "Email is required",
            invalidEmail: "Invalid email format",
            codeRequired: "Verification code is required",
            invalidCode: "Invalid verification code",
        },
    },
    config: {
        title: "System Settings",
        language: "System Language",
        languageLabel: "Language",
        saveButton: "Save Settings",
        saveSuccess:
            "Saved successfully! The language will be applied to the entire system.",
        saveError: "An error occurred while saving settings. Please try again.",
        languageChangeError: "Failed to change language",
    },
    menu: {
        post: "Posts",
        product: "Products",
        order: "Orders",
        storage: "Storage",
        chat: "Chat",
        config: "Settings",
        users: "Users",
        database: "Database",

        // Web
        home: "Home",
        about: "About Us",
        contact: "Contact",
        products: "Products",
    },
    login: {
        title: "Login",
        email: "Email",
        password: "Password",
        loginButton: "Login",
        forgotPassword: "Forgot password?",
        invalidCredentials: "Invalid email or password.",
    },
    product: {
        title: "Product Management",
        addNew: "Add New Product",
        createNew: "Create New Product",
        editProduct: "Edit Product",
        pageSize: "Page Size",
        noProductsFound:
            'No products found. Create your first product by clicking "Add New Product".',
        name: "Product Name",
        price: "Price",
        category: "Category",
        stock: "Stock",
        description: "Description",
        image: "Image",
        intro: "Introduction",
        seoSlug: "SEO Slug",
        seoSlugHelp:
            "URL-friendly name for product pages. Leave empty to auto-generate.",
        created: "Created",
        loadingError: "Failed to load product data",
        deleteConfirm: "Are you sure you want to delete this product?",
        deleteSuccess: "Product deleted successfully",
        deleteError: "Failed to delete product",
        createSuccess: "Product created successfully",
        createError: "Failed to create product",
        detail: {
            title: "Product Detail",
            media: "Media",
            info: "Info",
            config: "Config",
            variants: "Variants",
            basicInfo: "Basic Information",
            productName: "Product Name",
            slug: "Slug URL",
            generateSlug: "Generate Slug",
            slugPlaceholder: "Enter URL-friendly name",
            slugHelperText:
                "Used in product URLs. Leave empty to auto-generate from name.",
            slugGenerated: "Slug has been generated from product name",
            noHeadlineForSlug: "Please enter a product name first",
            price: "Price",
            prediscountPrice: "Original Price",
            content: "Content",
            intro: "Introduction",
            introPlaceholder: "Write short product introduction here...",
            introHelperText:
                "Short introduction displayed at the top of product page",
            contentPlaceholder: "Write detailed product description here...",
            contentHelperText: "Main product description shown on product page",
            uploadMedia: "Upload Media",
            dragToUpload: "Drag and drop files or click to upload",
            uploading: "Uploading...",
            viewMode: "View Mode",
            grid: "Grid",
            list: "List",
            attributes: "Attributes",
            attributeName: "Attribute Name",
            attributeValues: "Attribute Values",
            attributeValuesHint: "Enter values separated by commas",
            addAttribute: "Add Attribute",
            editAttribute: "Edit Attribute",
            attributeAdded: "Attribute added successfully",
            attributeUpdated: "Attribute updated successfully",
            noAttributes:
                "No attributes defined. Add attributes to generate product variants.",
            variantActive: "Active",
            variantLock: "Lock",
            variantOptions: "Options",
            productVariants: "Product Variants",
            noVariants:
                "No variants available. Add attributes first to generate variants.",
            regenerateVariants: "Regenerate Variants",
            setAsMain: "Set as Main",
            generalInfo: "General Information",
            variantInfo: "Variant Information",
            selectMedia: "Select Media",
            updatePrice: "Update Price",
            fileTypes: "JPG, PNG, GIF, WEBP up to 10MB",
            deleteVariant: "Delete Variant",
            generateVariants: "Generate Variants",
            addMediaToVariant: "Add media to variant",
            addMoreMedia: "Add more media",
            mediaAdded: "Media added to variant",
            mediaAlreadyAdded: "This media is already added to the variant",
            mediaRemoved: "Media removed",
            noMedia:
                "No media files attached to this product. Upload files using the button above.",
            variantColumn: "Variant",
            mediaColumn: "Media",
            priceColumn: "Price",
            statusColumn: "Status",
            saveSuccess: "Product saved successfully",
            saveError: "Failed to save product",
            mediaUploadSuccess: "Media uploaded successfully",
            mediaUploadError: "Failed to upload media",
            mediaDeleteSuccess: "Media removed",
            mediaDeleteError: "Failed to remove media",
            confirmDeleteVariant:
                "Are you sure you want to delete this variant?",
            confirmDeleteAttribute:
                "Are you sure you want to remove this attribute? This will also update product variants.",
            attributeDeleteSuccess: "Attribute removed successfully",
            urlCopied: "URL copied to clipboard",
            view: "View",
            priceRequired: "Cannot activate a variant without a price",
            priceActiveRequired: "Variants with a price must be active",
            noPriceLockedRequired:
                "Variants without a price must be locked or inactive",
            variantsRegenerated: "Variants regenerated",
            mediaNotFound: "Media not found",

            // New keys for API integration
            loadingError: "Failed to load product data",
            apiUpdateError: "Error communicating with server",
            variantUpdateError: "Failed to update variant",
            variantStatusError: "Failed to update variant status",
            variantLockError: "Failed to update variant lock status",
            mediaLinkError: "Failed to link media to variant",
            mediaUnlinkError: "Failed to remove media from variant",
            attributeDeleteError: "Failed to remove attribute",
            attributeAddError: "Failed to add attribute",
            unsupportedFileType: "Unsupported file type",
            supportedFileTypes: "Supported file types",
            seeDocumentation: "See documentation for supported file types",
            deleteMediaConfirm: "Are you sure you want to delete this media?",

            // New keys for upload panel
            selectedFiles: "Selected Files",
            uploadFiles: "UPLOAD FILES",
            clear: "Clear",
            pending: "Pending",
            uploading: "Uploading",
            completed: "Completed",
            error: "Error",
            remove: "Remove",
            fileTypeCategory: {
                IMAGE: "Image",
                AUDIO: "Audio",
                VIDEO: "Video",
                DOCUMENT: "Document",
                UNKNOWN: "Unknown",
            },
            
            // Filename validation
            filenameRules: "Filenames must only contain English letters, numbers, hyphens (-) and underscores (_). No spaces or special characters allowed.",
            invalidName: "Invalid Name",
            invalidFilenamesError: "{{count}} file(s) have invalid names. Only English letters, numbers, hyphens (-) and underscores (_) are allowed.",
            spaces: "spaces",
            nonEnglishChars: "non-English characters",
            specialChars: "special characters",
            invalidCharsDetected: "Invalid characters detected: {{chars}}",

            // Delete confirmation modal
            confirmDelete: "Confirm Delete",
            deleteConfirmMessage: "Are you sure you want to delete this media?",
            deleteError: "Failed to delete media",

            // Attribute management
            saveAttributes: "Save Attributes",
            saveAttributesTitle: "Save Attributes?",
            saveAttributesWarning:
                "Once attributes are saved, they cannot be modified later as this would affect product variants and orders. Are you sure you want to save these attributes?",
            attributesSaved: "Attributes saved successfully",
            attributeSaveError: "Failed to save attributes",
            discardAttributesTitle: "Discard Changes?",
            discardAttributesWarning:
                "You have unsaved attribute changes. Are you sure you want to discard them?",
            processingAttributes: "Processing...",
        },
    },
    order: {
        title: "Orders",
        status: "Status",
        pageSize: "Page Size",
        basicInfo: "Order Information",
        selectStatus: "Select status",
        fields: {
            orderId: "Order ID",
            customerName: "Customer",
            customerPhone: "Phone",
            customerEmail: "Email",
            customerAddress: "Address",
            totalAmount: "Amount",
            status: "Status",
            createdAt: "Created At",
            productInfo: "Product",
            quantity: "Quantity",
            unitPrice: "Unit Price",
            totalPrice: "Total",
            productId: "Product ID",
            variantId: "Variant ID",
            paymentMethod: "Payment Method",
            notes: "Notes",
        },
        detailTitle: "Order Details",
        noOrders: "No orders found",
        noOrderSelected: "No order selected",
        itemsPerPage: "Items per page",
        items: "Order Items",
        customerInfo: "Customer Information",
        updateStatus: "Update Status",
        filter: {
            allStatuses: "All Statuses"
        },

        search: {
            placeholder: "Search orders...",
            noResults: "No orders found",
            searchError: "Search error",
            searchSuccess: "Found {{count}} orders",
        },

        // Status options
        statusOptions: {
            new: "New",
            shipping: "Shipping",
            completed: "Completed",
            cancelled: "Cancelled",
            returned: "Returned",
            refunded: "Refunded"
        },

        // Payment methods
        paymentMethods: {
            cod: "Cash on Delivery",
            credit: "Credit Card",
            transfer: "Bank Transfer",
            wallet: "E-Wallet"
        },

        // Messages
        errorLoading: "Failed to load order data",
        orderUpdated: "Order status updated successfully",
        updateError: "Failed to update order status",
        deleteConfirm: "Are you sure you want to delete this order?",
        orderDeleted: "Order deleted successfully",
        orderSaved: "Order updated successfully",
        validationError: "Customer name and phone number are required",
        thankYou: "Thank You!",
        successMessage: "Your order has been placed successfully.",
        orderNumber: "Order Number",
        confirmationSent: "We've sent an order confirmation to your phone number.",
        trackingInfo: "You will receive updates about your order via SMS or call.",
        statusPending: "Pending",
        statusProcessing: "Processing",
        statusShipping: "Shipping",
        statusCompleted: "Completed",
        statusCancelled: "Cancelled",

        // Item related
        unknownProduct: "Unknown Product",
        noItems: "No items in this order",
    },
    storage: {
        title: "Storage Management",
        folders: "Folders",
        files: "Files",
        home: "Home",
        upload: "Upload Files",
        uploading: "Uploading...",
        uploadSuccess: "{count} file(s) uploaded successfully",
        uploadFailed: "Failed to upload files",
        emptyFolder: "This folder is empty",
        fileDetails: "File Details",
        fileName: "File Name",
        fileType: "File Type",
        fileSize: "Size",
        created: "Created",
        modified: "Modified",
        path: "Path",
        url: "URL",
        urlCopied: "URL copied to clipboard",
        download: "Download",
        viewDetails: "View Details",
        noPreview: "This file type cannot be previewed directly.",
        delete: "Delete",
        confirmDelete: 'Are you sure you want to delete "{name}"?',
        deleteSuccess: '"{name}" deleted',
        searchFolders: "Search folders...",
        dragToUpload: "Drag and drop files or click to upload",
        viewMode: {
            list: "List View",
            grid: "Grid View",
        },
    },
    chat: {
        title: "Chat Management",
        searchConversations: "Search conversations...",
        noConversations: "No conversations found",
        selectConversation: "Select a conversation to start chatting",
        online: "Online",
        away: "Away",
        offline: "Offline",
        typeMessage: "Type a message...",
        sendMessage: "Send message",
        messageSent: "Message sent",
        attachFiles: "Attach files",
        emoji: "Emoji",
        group: "Group",
        moreOptions: "More options",
    },
    user: {
        title: "User Management",
        accessControl: "System Access Control",
        allowAll: "Allow all users to login",
        restrictAccess: "Only allow whitelisted users to login",
        email: "Email",
        emailPlaceholder: "user@example.com",
        invalidGmail: "Please enter a valid Gmail address",
        role: "Role",
        add: "Add",
        edit: "Edit User",
        whitelistedUsers: "Whitelisted Users",
        saveConfig: "Save Configuration",
        saveSuccess: "User configuration saved successfully!",
        addSuccess: "User added successfully!",
        removeSuccess: "User removed successfully!",
        emailRequired: "Email is required",
        emailExists: "User with this email already exists",
        roleRequired: "Role is required",
        addError: "Failed to add user",
        updateSuccess: "User updated successfully",
        updateError: "Failed to update user",
        removeError: "Failed to remove user",
        fetchError: "Failed to fetch users",
        noPermission: "You do not have permission to manage users",
        deactivate: "DEACTIVATE USER",
        activate: "ACTIVATE USER",
        delete: "DELETE USER",
        activateSuccess: "User activated successfully",
        deactivateSuccess: "User deactivated successfully",
        deleteConfirmMessage:
            "Are you sure you want to delete {{email}}? This action cannot be undone.",
        roles: {
            root: "Root Admin",
            admin: "Administrator",
            content: "Content Manager",
            package: "Package Manager",
        },
    },
    database: {
        title: "Database Management",
        tabs: {
            dataTables: "Data Tables",
            sqlQuery: "SQL Query",
        },
        tables: {
            heading: "Database Tables",
            fetchError: "Failed to fetch tables",
            noTablesFound: "No tables found",
        },
        query: {
            inputLabel: "SQL Query",
            placeholder:
                "Enter your SQL query here (e.g., SELECT * FROM products LIMIT 10)",
            execute: "Execute",
            prompt: "Prompt",
            results: "Query Result",
            runAgain: "Run Again",
            recordsReturned: "{{count}} record(s) returned",
            noData: "No data returned",
            operation: "Operation",
            timestamp: "Timestamp",
        },
        prompt: {
            title: "Enter Prompt",
            inputLabel: "Prompt",
            placeholder: "Enter your prompt here...",
            process: "Process",
        },
        tableView: {
            title: "Table",
            defaultTitle: "Table Data",
            live: "Live",
            filter: "Filter",
            filteredData: "{{filtered}} of {{total}} records",
            showingRecords: "Showing up to 100 records from table",
            loadError: "Failed to fetch table data",
            noData: "No data in this table",
            editingCell: "Edit value",
            noMatchingData: "No data matches your filter criteria",
        },
        filter: {
            title: "Filter Data",
            applied: "Applied Filters",
            description:
                "Add conditions to filter table data. All conditions are combined with AND logic.",
            noConditions:
                'No filter conditions. Click "Add Condition" to create a filter.',
            column: "Column",
            operator: "Operator",
            value: "Value",
            addCondition: "Add Condition",
            clearFilters: "Clear Filters",
            clearAll: "Clear All",
            applyFilters: "Apply Filters",
            operators: {
                contains: "contains",
                equals: "=",
                startsWith: "starts with",
                endsWith: "ends with",
                greaterThan: ">",
                lessThan: "<",
            },
        },
        edit: {
            error: {
                noPrimaryKey:
                    "Cannot update: No primary key found for this table",
                updateFailed: "Failed to update:",
                genericError: "Error updating cell:",
            },
        },
    },
    validation: {
        required: "This field is required",
        invalidEmail: "Please enter a valid email address",
        invalidPhone: "Please enter a valid phone number",
        fullNameRequired: "Please enter your full name",
        phoneRequired: "Please enter your phone number",
        addressRequired: "Please enter your delivery address",
        addressMinLength: "Address must be at least 5 characters",
        addressMinLengthInfo: "Minimum 5 characters",
        invalidPhone: "Invalid phone number",
        invalidEmail: "Invalid email address"
    },
    footer: {
        description: "The most fun financial challenge in the solar system\n- Developed by The Cool Poor People-",
        quickLinks: "Quick Links",
        contactInfo: "Contact Information",
        hotline: "Hotline",
        email: "Email",
        address: "Address",
        copyright: "All rights reserved.",
    },
    home: {
        featuredCategories: "Featured Categories",
        category1: "Category 1",
        category2: "Category 2",
        category3: "Category 3",
        category4: "Category 4",
        featuredProducts: "Featured Products",
        productName: "Product {{id}}",
        productDescription: "Short description of the product goes here.",
        viewAllProducts: "View All Products",
        testimonials: "What Our Customers Say",
        testimonialText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Sed euismod, nisl vel ultricies tincidunt, nisl nisl aliquam nisl, eget aliquam nisl nisl sit amet nisl.",
        customerName: "Customer {{id}}",
        customerLocation: "Location {{id}}",
    },
    cart: {
        title: "Shopping Cart",
        empty: "Your cart is empty",
        emptyDescription: "Looks like you haven't added any products to your cart yet.",
        continueShopping: "Continue Shopping",
        items: "{{count}} item(s) in your cart",
        subtotal: "Subtotal",
        shipping: "Shipping",
        discount: "Discount",
        tax: "Tax",
        total: "Total",
        checkout: "Proceed to Checkout",
        deliveryInfo: "Delivery Information",
        fullName: "Full Name",
        phone: "Phone Number",
        address: "Delivery Address",
        email: "Email (Optional)",
        notes: "Order Notes (Optional)",
        confirmOrder: "Confirm Order",
        confirmYourOrder: "Confirm Your Order",
        orderConfirmation: "Order Confirmation",
        customerInfo: "Customer Information",
        orderItems: "Order Items",
        paymentPolicy: "This order will be delivered COD (Cash On Delivery). You will pay when you receive the products.",
        placeOrder: "Confirm & Place Order",
        orderSuccess: "Your order has been placed successfully! Order number: {{orderNumber}}",
        orderError: "There was an error placing your order. Please try again.",
        quantity: "Quantity",
        unitPrice: "Unit Price",
        itemTotal: "Item Total",
        summary: "Order Summary",
        
        // Additional cart page translations
        backToCart: "Back to Cart",
        removeItem: "Remove Item",
        updateQuantity: "Update Quantity",
        paymentMethod: "Payment Method",
        cod: "Cash On Delivery (COD)",
        orderPlaced: "Order placed successfully!",
        processingOrder: "Processing your order",
        pleaseWait: "Please wait a moment...",
        confirmPlace: "Place Order",
        orderSummary: "Order Summary",
        product: "Product",
        price: "Price",
        addressPlaceholder: "Please enter your full address (minimum 5 characters)",
        addToCart: "Add to Cart",
        buyNow: "Buy Now",
        productAdded: "Product added to cart",
        goToCart: "Go to Cart",
        update: "Update",
        remove: "Remove",
        applyCoupon: "Apply Coupon",
        couponCode: "Coupon Code",
        apply: "Apply",
        invalidCoupon: "Invalid or expired coupon code",
        couponApplied: "Coupon applied: {{code}}",
        estimatedTotal: "Estimated Total",
        itemsInCart: "Items in Cart",
        outOfStock: "Out of Stock",
        lowStock: "Only {{count}} left",
        freeTaxes: "Tax Free",
        freeShipping: "Free Shipping",
        thankYouForOrder: "Thank you for your order!",
    },
};
